export default theme => ({
  wrapper: {
    paddingBottom: props => {
      if (props.noPadding) {
        return 0;
      }

      const padding = (props.spacing === 0 || props.spacing > 0) ? props.spacing : props.theme.spacing.unit;
      return padding;
    },
    fontSize: 13
  },
  tabsRoot: {
    backgroundColor: '#fff',
    padding: 0,
  },
  tabsIndicator: {
    backgroundColor: '#fc4a38',
    color: '#0f0f0f'
  },
  tabRoot: {
    padding: 0,
    minWidth: 'auto',
    minHeight: 48,
  },
  tabsLabelContainer: {
    padding: '6px 0'
  },
  tabSelected: {
    // borderBottom: '2px solid #fc4a38',
  },
  tabWrapper: {
    padding: 0
  },
  container: {
    border: props => {
      const noBorder = props.noBorder === true || props.border === false;
      const border = props.border || 1;
      return noBorder ? 'none' : `${border}px solid #E0E0E0`;
    },
  },
  containerPadding: {
    padding: 2,
  },
  containerGray: {
    backgroundColor: '#f5f5f5',
  },
  title: {
    color: '#fc4a38',
    borderBottom: '3px solid #fc4a38',
    lineHeight: 1.7,
    fontSize: 16,
    fontWeight: 'bold',
    padding: 10,
  },
  secondaryMenu: {
    background: '#000',
    '& a': {
      padding: '2px 0',
      color: '#fff',
    }
  },
  toolbar: {
    padding: 0,
    alignItems: 'stretch',
  },
  logoLink: {
    // flexGrow: 1,
  },
  menuList: {
    margin: 0,
    padding: 0
  },
});